<template>
  <i
    class="sport-icon-liga-white"
    :class="{
      [this.name + '-sport-icon']: true,
      gray: this.gray !== undefined && this.gray,
      small: small,
      medium: medium
    }">
  </i>
</template>

<script>
export default {
  props: {
    name: String,
    gray: Boolean,

    small: Boolean,
    medium: Boolean
  }
}
</script>

<style scoped>
.sport-icon-liga-white { background: url(../../assets/sport-icons.png); background-size: 160px 112px; display: inline-block; height: 16px; width: 16px; }
.sport-icon-liga-white.gray { -webkit-filter: grayscale(100%); -moz-filter: grayscale(100%); -ms-filter: grayscale(100%); -o-filter: grayscale(100%); filter: grayscale(100%); filter: gray; }
.all-sports-icon { background-position: 0 0; }
.football-sport-icon { background: center  url(../../assets/sports/soccer.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.basketball-sport-icon { background: center  url(../../assets/sports/basketball.svg); height: 24px; width: 24px; background-size: 24px; color: white;}
.tennis-sport-icon { background: center  url(../../assets/sports/tennis.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.ice-hockey-sport-icon { background: center  url(../../assets/sports/hockey.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.baseball-sport-icon { background: center  url(../../assets/sports/baseball.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.formula-sport-icon { background-position: -96px 0; }
.volleyball-sport-icon { background: center  url(../../assets/sports/volleyball.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.snooker-sport-icon { background: center  url(../../assets/sports/snooker.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.fight-sport-icon { background: center  url(../../assets/sports/fight.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.handball-sport-icon { background: center  url(../../assets/sports/handball.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.boxing-sport-icon { background: center  url(../../assets/sports/boxing.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.badminton-sport-icon { background: center  url(../../assets/sports/badminton.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.rugby-sport-icon { background: center  url(../../assets/sports/rugby.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.futsal-sport-icon { background: center  url(../../assets/sports/soccer.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.table-tennis-sport-icon { background: center  url(../../assets/sports/table-tennis.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.beach-volleyball-sport-icon { background-position: -96px -16px; }
.american-football-sport-icon { background: center  url(../../assets/sports/american-football.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.darts-sport-icon { background: center  url(../../assets/sports/darts.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.bandy-sport-icon { background-position: -144px -16px; }
.bocce-sport-icon { background-position: 0 -32px; }
.cricket-sport-icon { background: center  url(../../assets/sports/cricket.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.pool-sport-icon { background: center  url(../../assets/sports/pool.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.field-hockey-sport-icon { background-position: -48px -32px; }
.roller-hockey-sport-icon { background: center  url(../../assets/sports/pool.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.lottery-sport-icon { background-position: -80px -32px; }
.chess-sport-icon { background: center  url(../../assets/sports/chess.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.biathlon-sport-icon { background: center  url(../../assets/sports/biathlon.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.squash-sport-icon { background: center  url(../../assets/sports/squash.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.floorball-sport-icon { background-position: -144px -32px; }
.water-polo-sport-icon { background: center  url(../../assets/sports/water-polo.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.ski-jumping-sport-icon { background-position: -16px -48px; }
.poker-sport-icon { background: center  url(../../assets/sports/poker-chip.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.curling-sport-icon { background: center  url(../../assets/sports/curling.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.figure-skating-sport-icon { background-position: -64px -48px; }
.eurovision-sport-icon { background-position: -80px -48px; }
.cycle-racing-sport-icon { background: center  url(../../assets/sports/bike.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.athletics-sport-icon { background: center  url(../../assets/sports/weight-lifter.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.sumo-sport-icon { background-position: -128px -48px; }
.beach-football-sport-icon { background: center  url(../../assets/sports/soccer.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.horse-racing-sport-icon { background: center  url(../../assets/sports/horse-variant-fast.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.golf-sport-icon { background: center  url(../../assets/sports/golf.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.cyber-sport-icon { background: center  url(../../assets/sports/google-controller.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.cyberfootball-sport-icon { background: center  url(../../assets/sports/google-controller.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.сyberhockey-sport-icon { background: center  url(../../assets/sports/google-controller.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.сyberbasketball-sport-icon { background: center  url(../../assets/sports/google-controller.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.сybertennis-sport-icon { background: center  url(../../assets/sports/google-controller.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.australian-football-sport-icon { background: center  url(../../assets/sports/football-australian.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.judo-sport-icon { background-position: -64px -64px; }
.motorcycle-sport-icon { background: center  url(../../assets/sports/motorbike.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.archery-sport-icon { background-position: -96px -64px; }
.oplympics-sport-icon { background-position: -112px -64px; }
.ice-skates-sport-icon { background: center  url(../../assets/sports/skate.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.car-race-sport-icon { background: center  url(../../assets/sports/car-sports.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.skiing-sport-icon { background: center  url(../../assets/sports/ski.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.gaelic-sport-icon { background-position: -16px -80px; }
.snowboarding-sport-icon { background: center  url(../../assets/sports/snowboard.svg); height: 24px; width: 24px; background-size: 24px; color: white; }
.freestyle-sport-icon { background-position: -48px -80px; }
.bobsled-sport-icon { background-position: -64px -80px; }
.toboggan-sport-icon { background-position: -80px -80px; }
.skeleton-sport-icon { background-position: -96px -80px; }
.short-track-sport-icon { background-position: -112px -80px; }
.cross-country-skiing-sport-icon { background-position: -128px -80px; }

.corner-sport-icon { background-position: 0 -96px; }
.yellow-card-sport-icon { background-position: -16px -96px; }

.medium.sport-icon { background-size: 100px 70px; height: 10px; width: 10px; }
.medium.tennis-sport-icon { background-position: -30px 0; }
.medium.volleyball-sport-icon { background-position: -70px 0; }
.medium.snooker-sport-icon { background-position: -80px 0; }
.medium.badminton-sport-icon { background-position: -20px -10px; }
.medium.table-tennis-sport-icon { background-position: -50px -10px; }
.medium.beach-volleyball-sport-icon { background-position: -60px -10px; }

.medium.corner-sport-icon { background-position: 0 -60px; }
.medium.yellow-card-sport-icon { background-position: -10px -60px; }

.small.sport-icon { background-size: 40px 28px; height: 4px; width: 4px; }
.small.tennis-sport-icon { background-position: -12px 0; }
.small.volleyball-sport-icon { background-position: -28px 0; }
.small.snooker-sport-icon { background-position: -32px 0; }
.small.badminton-sport-icon { background-position: -8px -4px; }
.small.table-tennis-sport-icon { background-position: -20px -4px; }
.small.beach-volleyball-sport-icon { background-position: -24px -4px; }

.small.corner-sport-icon { background-position: 0 -24px; }
.small.yellow-card-sport-icon { background-position: -4px -24px; }
</style>



// WEBPACK FOOTER //
// src/components/icons/SportIconLigaWhite.vue